// extracted by mini-css-extract-plugin
export var TextAccordionItem = "TextAccordionItem-module--TextAccordionItem--pSk8n";
export var aniSpin = "TextAccordionItem-module--ani-spin--Wo-ez";
export var content = "TextAccordionItem-module--content--vCHht";
export var content__inner = "TextAccordionItem-module--content__inner--Hcd1G";
export var head = "TextAccordionItem-module--head--z0aK8";
export var heading = "TextAccordionItem-module--heading--45IJl";
export var icon = "TextAccordionItem-module--icon--drNwJ";
export var icon__collapse = "TextAccordionItem-module--icon__collapse--1Q+Q-";
export var icon__expand = "TextAccordionItem-module--icon__expand--kpOCp";